import React from 'react';
import { QUIZ_MATCH_BLOCK } from '..';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import {
  LeftMatchItem,
  QuizMatchProvider,
  RightMatchItem
} from './QuizMatchStore';
import { QuizMatchBlockRoot } from '~/training/sequence/templates/items/quiz-match/components/QuizMatchBlockRoot';
// import { QuizMatchStepsRoot } from '~/training/sequence/templates/items/quiz-match/components/QuizMatchStepsRoot';

interface Props {
  variant?: string;
  leftItems: LeftMatchItem[];
  rightItems: RightMatchItem[];
}

export type QuizMatchBlockDefinition = ItemDefinition<
  typeof QUIZ_MATCH_BLOCK,
  Props
>;

export class QuizMatchBlock extends Item<typeof QUIZ_MATCH_BLOCK, Props> {
  protected render({
    leftItems,
    rightItems,
    id,
    variant = 'list'
  }: RenderProps<Props>) {
    return (
      <QuizMatchProvider leftItems={leftItems} rightItems={rightItems}>
        <QuizMatchBlockRoot id={id} />
      </QuizMatchProvider>
    );
  }
}

registry[QUIZ_MATCH_BLOCK] = QuizMatchBlock;
